import TableTemplate from "../../../TableTemplate/tableTemplate";
import { IDetailedStateAdjustmentTablesSearchParam } from "../../../../Interfaces/deltaHedgeExe";
import { CommonTableUI } from "../../../TableTemplate/common";
import { getDetailedStateAdjustmentDeltaGammaTable } from "../../../../Requests/adjustment";

interface IProps {
  searchParams: IDetailedStateAdjustmentTablesSearchParam;
}

const DeltaGamma = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IDetailedStateAdjustmentTablesSearchParam, any>
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          tableBoxClassName="!max-h-[300px] order-table"
        />
      )}
      getDataTable={getDetailedStateAdjustmentDeltaGammaTable}
      initialSearchParameters={searchParams}
    />
  );
};

export default DeltaGamma;
